import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule, PreloadAllModules, NoPreloading } from '@angular/router';
import { LoginComponent } from 'src/app/components/login/login.component';
import { ForgetPasswordComponent } from '../components/forget-password/forget-password.component';
import { ResetPasswordComponent } from '../components/reset-password/reset-password.component';
import { HomeComponent } from 'src/app/components/home/home.component';
import { UserProfileComponent } from 'src/app/components/user-profile/user-profile.component';
import { ChangePwdComponent } from 'src/app/components/user-profile/change-pwd/change-pwd.component';
import { CreateCompanyProfileComponent } from 'src/app/components/company-profile/create-company-profile/create-company-profile.component';
import { AuthGuardService } from 'src/app/services/auth-guard.service';
import { NotfoundComponent } from '../components/notfound/notfound.component';
import { RegisterComponent } from '../components/register/register.component';
import { CountDownComponent } from '../components/count-down.component';
import { Page404Component } from '../components/notfound/404-page.componenet';
import { CAPaymentLoadingComponent } from '../components/ca-confirm-payment/ca-payment-loading.component';
import { MyWalletComponent } from '../components/finance/wallet/my-wallet-component';
import { WalletComponent } from '../components/finance/wallet/wallet.component';
import { PaymentLoadingComponent } from '../components/finance/wallet/payment-loading.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'forgot-password', component: ForgetPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'invite/:id', component: RegisterComponent },
  { path: 'error-404/:message', component: Page404Component },
  { path: 'reset-pwd', component: CountDownComponent },
  { path: 'ca-confirm-payment/:token/:txnRefNum', component: CAPaymentLoadingComponent },
  {
    path: 'cit', component: HomeComponent, canActivate: [AuthGuardService],
    children: [
      { path: '403-error', component: NotfoundComponent },
      { path: 'dashboard', loadChildren: () => import('src/app/components/dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuardService] },
      { path: 'user-profile', component: UserProfileComponent, canActivate: [AuthGuardService] },
      { path: 'change-pwd', component: ChangePwdComponent, canActivate: [AuthGuardService] },
      { path: 'company', loadChildren: () => import('src/app/components/company/company.module').then(m => m.CompanyModule), canActivate: [AuthGuardService] },
      { path: 'company-profile', children: [ { path: 'create', component: CreateCompanyProfileComponent, canActivate: [AuthGuardService] }] },
      { path: 'manifest', loadChildren: () => import('src/app/components/manifest/manifest.module').then(m => m.ManifestModule), canActivate: [AuthGuardService] },
      { path: 'shipment', loadChildren: () => import('src/app/components/shipment/shipment.module').then(m => m.ShipmentModule), canActivate: [AuthGuardService] },
      { path: 'address-book', loadChildren: () => import('src/app/components/address-book/address-book.module').then(m => m.AddressBookModule), canActivate: [AuthGuardService] },
      { path: 'retail-inbound', loadChildren: () => import('src/app/components/retail-inbound-scan/retail-inbound-scan.module').then(m => m.RetailInboundScanModule), canActivate: [AuthGuardService] },
      { path: 'reports', loadChildren: () => import('src/app/components/reports/reports.module').then(m => m.ReportsModule), canActivate: [AuthGuardService] },
      { path: 'pos', loadChildren: () => import('src/app/components/pos/pos.module').then(m =>m.PosModule), canActivate: [AuthGuardService] },
      { path: 'booking', loadChildren: () => import('src/app/components/booking/booking.module').then(m =>m.BookingModule), canActivate: [AuthGuardService] },
      { path: 'finance', loadChildren: () => import('src/app/components/finance/finance.module').then(m =>m.FinanceModule), canActivate: [AuthGuardService] },
      {
        path: 'statements',
        canActivate: [AuthGuardService],
        loadChildren: ()=>import('src/app/components/statement/statement.module').then((m)=>m.StatementModule,)
      },{ path: '', redirectTo: 'dashboard/view', pathMatch: 'full' }

      // {
      //   path: 'inbound-scan-statement',
      //   component: InboundStatementScanComponent
      // }
    ]
  },
  { path: '**', redirectTo: '/cit/dashboard/view' }
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(
      routes,
      {
        useHash: true,
        scrollPositionRestoration: 'top',
        preloadingStrategy: NoPreloading
      })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
